import { Frame } from '@/store'
import { Component, Prop, Vue, Inject } from 'vue-property-decorator'
import { ContextMenuComponent } from '@/App/Main/Frame/ContextMenu/script'
import { CatalogOverplotModule } from '..'
import { CatalogOverplot } from '../CatalogOverplot'
import { EquatorialCoord } from '@hscmap/angle'

@Component
export default class extends Vue {
  @Inject('contextMenu')
  contextMenu!: ContextMenuComponent

  @Prop({ required: true })
  frame!: Frame

  @Prop({ required: true })
  module!: CatalogOverplotModule

  get cos() {
    return this.frame.modules.catalogOverPlot.cos.filter(c => c.editable)
  }

  addCoordToCatalog(co: CatalogOverplot, eq: EquatorialCoord) {
    co.coord3.push(eq.xyz)
    co.rows.push([String(eq.a.deg), String(eq.d.deg), ''])
  }

  addClickedCoordToCatalog(co: CatalogOverplot) {
    const eq = this.contextMenu.coord()
    this.addCoordToCatalog(co, eq)
  }

  newCatalog() {
    const name = prompt('Catalog Name ?')
    if (name) {
      const newCatalog = CatalogOverplot.make({
        name,
        rows: [],
        coord3: [],
        header: ['ra', 'dec', 'Note'],
      }, { editable: true })
      this.frame.modules.catalogOverPlot.cos.push(newCatalog)
      newCatalog.showTable = true
      this.addCoordToCatalog(newCatalog, this.contextMenu.coord())
    }
  }
}
